import { FunctionComponent } from "react";
import { Tooltip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

type PropsType = {
  valid: boolean | null | undefined;
  warningTooltip?: string;
};

/**
 * Tri-state validity indicator:
 * - null / undefined → renders nothing (validity not yet known)
 * - false → amber warning icon with tooltip
 * - true → subtle green check icon
 */
const ValidityIndicator: FunctionComponent<PropsType> = ({
  valid,
  warningTooltip = "Invalid ean",
}) => {
  if (valid === false) {
    return (
      <Tooltip title={warningTooltip} placement="top">
        <WarningAmberIcon
          fontSize="small"
          sx={{ color: "warning.main", verticalAlign: "middle", ml: 0.5 }}
        />
      </Tooltip>
    );
  }

  if (valid === true) {
    return (
      <CheckCircleOutlineIcon
        fontSize="small"
        sx={{
          color: "success.main",
          verticalAlign: "middle",
          ml: 0.5,
          opacity: 0.7,
        }}
      />
    );
  }

  return null;
};

export default ValidityIndicator;
